import { WebPlugin } from '@capacitor/core';
export class NotificareAssetsPluginWeb extends WebPlugin {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async fetch(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map